// Libraries
import React from 'react';

// Components
import { Page } from 'components/Page';
import { H1 } from 'components/Typography';
// Styles
import styles from './Permission.module.scss';

const Permission = (): React.ReactElement<typeof Page> => (
  <Page
    classes={{
      root: styles.Root,
      container: styles.Container
    }}
  >
    <H1>
      Недостаточно прав.
    </H1>
  </Page>
);

// Exports
export default Permission;
